import './css/desktop/shop.scss';
import './shim';
import $ from 'jquery';

import { setTranslations } from './legacy/home24/core/translation';
import client from './legacy/home24-shared/core/Client';
import { setConfig } from './legacy/home24/core/config';
import { initialize as initializeValidation } from './legacy/home24-desktop/validation/validation-controller';

if (module.hot) {
    module.hot.accept();
}

const { appDomainId, language } = client.getInformation();
const config = require('promise?global!./generated/config.js');
const validation = require(`promise?global!./generated/validation-${appDomainId}.js`);
const translation = require(`promise?global!./generated/translation-${appDomainId}-${language}.js`);

Promise.all([
    config(),
    validation(),
    translation()
]).then((configs) => {
    setConfig(configs[0]);
    setTranslations(configs[2]);
    initializeValidation($.extend(true, {}, configs[1], configs[1].validation));

    // eslint-disable-next-line global-require
    require('./legacy/desktop-app');
});



/** WEBPACK FOOTER **
 ** ./desktop.js
 **/